export default __webpack_public_path__ + "static/media/greenbag.052d20ff.svg";